<div class="flex-row d-xl-flex d-none">
  <div *ngFor="let togg of keys(_toggles)" class="mr-3">
    <sb-threeway-toggle-button [disabled]="disabled" [(model)]="toggleModel[togg]" class="ml-1 mr-1 mb-1"
                               (modelChange)="onChange(togg, $event)">
      <ng-container *ngIf="icons && icons[togg]">
        <sb-icon [icon]="icons[togg]"></sb-icon>
      </ng-container>
      <ng-container *ngIf="titles && titles[togg]">
        {{titles[togg]}}
      </ng-container>
    </sb-threeway-toggle-button>
  </div>
</div>
<div ngbDropdown placement="bottom-right" class="d-flex d-xl-none" title="Attribute Filter">
  <sb-button classes="btn-clean" ngbDropdownToggle>
    <sb-icon *ngFor="let togg of keys(_toggles)"
             [ngClass]="toggleModel[togg]==-1 ? 'grey' : toggleModel[togg]==1 ? 'green' : 'red'"
             class="singleEllipsis-h"
             icon="circleFilled"></sb-icon>
  </sb-button>
  <div ngbDropdownMenu>
    <ul class="dropdown">
      <li class="head"> Attribute Filter</li>
      <li class="separator"></li>
      <li class="item" *ngFor="let togg of keys(_toggles)">
        <a class="item-link">
          <sb-threeway-toggle-button [disabled]="disabled" [(model)]="toggleModel[togg]" class="ml-1 mr-1 mb-1"
                                     (modelChange)="onChange(togg, $event)">
            <ng-container *ngIf="icons && icons[togg]">
              <sb-icon [icon]="icons[togg]"></sb-icon>
            </ng-container>
            <ng-container *ngIf="titles && titles[togg]">
              {{titles[togg]}}
            </ng-container>
          </sb-threeway-toggle-button>
        </a>
      </li>
    </ul>
  </div>
</div>
